import React from "react";
// import { Box, Stack, Card, CardContent, Typography } from "@mui/material";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../auth/RequirePermission3";
import PostAddIcon from '@mui/icons-material/PostAdd'; // For Create Bill
import PendingActionsIcon from '@mui/icons-material/PendingActions'; // For Waiting
import PriceCheckIcon from '@mui/icons-material/PriceCheck'; // For Paid
import HighlightOffIcon from '@mui/icons-material/HighlightOff'; // For Cancel
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
export default function CameraPanel() {
  const navigate = useNavigate();

  const handleClick = (url) => {
    navigate(url);
  };

  const statusButtons = React.useMemo(
    () => [
      ...(hasPermission(["ticket_open_purchase_sale"])
        ? [
          {
            label: "สร้างบิลใหม่",
            color: "bg-gray-900", // Adjusted from #1c1e2a
            textColor: "text-white",
            iconColor: "text-gray-900",
            bgColor: "bg-gray-100",
            icon: <RequestQuoteIcon style={{ fontSize: 40 }} />,
            url: "/buy/customers",
          },
        ]
        : []),
      {
        label: "บิลรอจ่าย",
        color: "bg-blue-500", // Adjusted from #42a5f5 (blue-400/500)
        textColor: "text-gray-800",
        iconColor: "text-blue-500",
        bgColor: "bg-blue-50",
        icon: <PendingActionsIcon style={{ fontSize: 40 }} />,
        url: "/buy/ticket?status=waiting",
      },
      {
        label: "บิลจ่ายแล้ว",
        color: "bg-green-500", // Adjusted from #b2f2bb (green-200) to more vibrant green-500 for icon
        textColor: "text-gray-800",
        iconColor: "text-green-500",
        bgColor: "bg-green-50",
        icon: <PriceCheckIcon style={{ fontSize: 40 }} />,
        url: "/buy/ticket?status=payed",
      },
      {
        label: "บิลที่ถูกยกเลิก",
        color: "bg-red-500", // Adjusted from #f8d7da (red-100) to red-500 for icon
        textColor: "text-gray-800",
        iconColor: "text-red-500",
        bgColor: "bg-red-50",
        icon: <HighlightOffIcon style={{ fontSize: 40 }} />,
        url: "/buy/ticket?status=cancel",
      },
    ],
    []
  );

  return (
    <div className="h-[calc(100vh-64px)] bg-gray-50 flex flex-col w-full">
      <div className="w-full max-w-7xl mx-auto p-4 md:p-8">
        <AppBreadcrumbs />
      </div>

      <div className="flex-1 flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 md:px-8 pb-4 md:pb-8">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
          {statusButtons.map((item) => (
            <div
              key={item.url}
              onClick={() => handleClick(item.url)}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1 group"
            >
              <div className={`w-20 h-20 rounded-2xl ${item.bgColor} ${item.iconColor} flex items-center justify-center mb-6 shadow-inner transition-transform group-hover:scale-110`}>
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-700 group-hover:text-gray-900 text-center">
                {item.label}
              </h3>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
